import * as React from 'react';
import { BasePureComponent } from './BaseComponent';
import { ChiamaAPI, Trad, Tipo, CampoNumero, CampoStringa } from './';
import * as Dati from '../Dati';
import * as DatiRCP from '../DatiRCP';
import * as Glob from '../Globale';
import { TipoCampoTesto } from './TipiCampi';
import { InputTesto } from './InputTesto';

interface IGaranziaProps extends Dati.IBaseProps {
    Value: Glob.DatiJSON; //JSON
    Forzabile?: boolean;
    Disabilitato?: boolean;
}

export class Garanzia extends BasePureComponent<IGaranziaProps> {

    private _Garanzia: DatiRCP.CGaranzia = new DatiRCP.CGaranzia();
    private _Forzabile: boolean = false;

    public constructor(props: any) {
        super(props);
        this.OnAggiorna = this.OnAggiorna.bind(this);
    }

    protected OnAggiorna(e: React.FormEvent<any> | string, valore?: any): void {
        if (typeof (e) != "string") {
            this._Garanzia.Dati[e.currentTarget.name] = e.currentTarget.value;
        }
        this.props.OnChange(this.props.Name, JSON.stringify(this._Garanzia));
    }

    private PopolaValori() {
        this._Forzabile = this.props.Forzabile != undefined ? this.props.Forzabile : false;
        this._Garanzia = new DatiRCP.CGaranzia();
        if (this.props.Value != undefined && this.props.Value != "")
            this._Garanzia = JSON.parse(this.props.Value);
        else
            this._Garanzia = new DatiRCP.CGaranzia();
    }

    private IconaMigliorPrezzo(): string {
        if (this._Garanzia.MigliorPremio == Glob.PremioMigliore && this._Garanzia.Abilitata && this._Garanzia.Semaforo == DatiRCP.SemaforoVerde)
            return "fa fa-smile-wink verde fa-lg";  //"fa fa-hand-peace verde";
        else if (this._Garanzia.MigliorPremio == Glob.PremioStandard && this._Garanzia.Abilitata && this._Garanzia.Semaforo == DatiRCP.SemaforoVerde)
            return "fa fa-smile arancione fa-lg"; //"fa fa-equals giallo";
        else if (this._Garanzia.MigliorPremio == Glob.PremioPeggiore && this._Garanzia.Abilitata && this._Garanzia.Semaforo == DatiRCP.SemaforoVerde)
            return "fa fa-sad-tear rosso fa-lg"; //"fa fa-hand-point-down rosso";
        else
            return "fa fa-minus-circle rosso fa-lg";//"fa fa-minus-circle rosso";
    }

    private Disabilitata(): string {
        if (this._Garanzia.Abilitata && this._Garanzia.Semaforo == DatiRCP.SemaforoVerde)
            return "";
        else
            return "disabilitato";
    }

    private VisualizzaInfo(): any {
        let info: any[] = [];
        let i: number = -1;
        for (let key in this._Garanzia.Dati) {
            i++;
            if (this._Forzabile) {
                if (Glob.isNumber(this._Garanzia.Dati[key])) {
                    info.push(<div key={i} className="form-group kt-form login-form__group input-group-sm">
                        <div className="input-group input-group-sm">
                            <div className="input-group-prepend">
                                <span className="input-group-text" id="basic-addon2">
                                    <i className="" aria-hidden="true">{Trad.Trad(key)}</i>
                                </span>
                            </div>
                            <CampoNumero Id={key} Name={key} Valore={this._Garanzia.Dati[key]} OnChange={this.OnAggiorna} CSS="form-control kt-input" Disabilitato={this.props.Disabilitato} />
                        </div>
                    </div>)
                } else {
                    info.push(<div key={i} className="form-group kt-form login-form__group input-group-sm">
                        <div className="input-group input-group-sm">
                            <div className="input-group-prepend">
                                <span className="input-group-text" id="basic-addon2">
                                    <i className="" aria-hidden="true">{Trad.Trad(key)}</i>
                                </span>
                            </div>
                            <CampoStringa Id={key} Name={key} Valore={this._Garanzia.Dati[key]} OnChange={this.OnAggiorna} CSS="form-control kt-input" Disabilitato={this.props.Disabilitato} />
                        </div>
                    </div>)
                }
            } else {
                if (Glob.isNumber(this._Garanzia.Dati[key]))
                    if (Number.isInteger(this._Garanzia.Dati[key]))
                        info.push(<div className="kt-widget3__item" key={i}><span>{Trad.Trad(key)}:</span> <span className="kt--font-success">{new Intl.NumberFormat(Trad.FormatoLingua(), { currency: Trad.FormatoImporto(), minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(this._Garanzia.Dati[key])}</span></div>);
                    else
                        info.push(<div className="kt-widget3__item" key={i}><span>{Trad.Trad(key)}:</span> <span className="kt--font-success">{new Intl.NumberFormat(Trad.FormatoLingua(), { currency: Trad.FormatoImporto(), minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(this._Garanzia.Dati[key])}</span></div>);
                else
                    info.push(<div className="kt-widget3__item" key={i}><span>{Trad.Trad(key)}:</span> <span className="kt--font-success">{Trad.Trad(this._Garanzia.Dati[key])}</span></div>);
            }
        }

        return info;
    }

    private VisualizzaMessaggio(): any {
        if (this._Garanzia.Messaggio == "")
            return false;

        if (this._Garanzia.Semaforo == DatiRCP.SemaforoVerde)
            return <div className="kt-widget3__item"><span>{Trad.Trad("Info")}:</span> <i className="fa fa-info-circle info"></i><span className="kt--font-info">{this._Garanzia.Messaggio}</span></div>;
        if (this._Garanzia.Semaforo == DatiRCP.SemaforoGiallo)
            return <div className="kt-widget3__item"><span>{Trad.Trad("Warning")}:</span> <i className="fa fa-exclamation-circle warning"></i> <span className="kt--font-warning">{this._Garanzia.Messaggio}</span></div>;
        if (this._Garanzia.Semaforo == DatiRCP.SemaforoRosso)
            return <div className="kt-widget3__item"><span>{Trad.Trad("Errore")}:</span> <i className="fa fa-times-circle info"></i> <span className="kt--font-wrong">{this._Garanzia.Messaggio}</span></div>;
    }

    private renderGraficaGaranzia(tipoFondo: string, azione: any): any {
        return <div className={"kt-widget4 dashedborder " + tipoFondo + " " + this.Disabilitata()}>
            <div className="kt-widget4__item">
                <div className="kt-widget4__info">
                    <span className="kt-widget4__title">
                        <h6> {Trad.Trad(this._Garanzia.ID_TipoGaranzia)}</h6>
                    </span>
                    <span className="kt-widget4__sub">
                        {this.VisualizzaMessaggio()}
                        {this.VisualizzaInfo()}
                    </span>
                </div>
                <span className="kt-widget4__ext">
                    <span className="kt-widget4__number kt--font-brand"> <h5> {Trad.TradParam("{1-I}", [this._Garanzia.ImportoLordo])}</h5></span>
                </span>

            </div>
        </div>;
    }


    private renderGraficaGaranziaBase(): any {
        return this.renderGraficaGaranzia("base", "");
    }

    private renderGraficaGaranziaAccessoria(): any {
        //return this.renderGraficaGaranzia("", <div className="btn btn-brand kt-btn kt-btn--icon btn-sm btn--icon-only"><i className="la la-minus"></i></div>);
        return this.renderGraficaGaranzia("", "");
    }

    public render() {
        this.PopolaValori();

        if (this._Garanzia.Base) {
            return this.renderGraficaGaranziaBase();
        }
        else {
            return this.renderGraficaGaranziaAccessoria();
        }
    }
}




// WEBPACK FOOTER //
// ./src/components/Garanzia.tsx